import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import('../views/AboutView.vue')
  // },
  {
    path: '/shareRoute',
    name: 'shareRoute',
    component: () => import('../views/shareRoute.vue')
  },
  {
    path: '/shareLive',
    name: 'shareLive',
    component: () => import('../views/shareLive.vue')
  },
  {
    path: '/shareLiveMobile',
    name: 'shareLiveMobile',
    component: () => import('../views/shareLiveMobile.vue')
  },
  {
    path: '/liveRoute',
    name: 'liveRoute',
    component: () => import('../views/liveRoute.vue')
  },
  {
    path: '/livePC',
    name: 'livePC',
    component: () => import('../views/livePC.vue')
  },
  {
    path: '/liveMobile',
    name: 'liveMobile',
    component: () => import('../views/liveMobile.vue')
  }
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
